var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlarmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.5C1.6175 5.5 0.5 4.3825 0.5 3C0.5 1.6175 1.6175 0.5 3 0.5C4.3825 0.5 5.5 1.6175 5.5 3C5.5 4.3825 4.3825 5.5 3 5.5Z",
    fill: "#801082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmIcon);
export default __webpack_public_path__ + "static/media/alarm-icon.a2c7f02718531f33ad2b39832bebe8b3.svg";
export { ForwardRef as ReactComponent };